export const INSIGHT_DETAIL = {
  LEVEL: 'Criticality level',
  DESCRIPTION: 'Description',
  AFFECTED_RESOURCES: 'Affected Resources',
  AFFECTED_USERS: 'Affected Users',
  PERCENTAGE: 'Percentage',
  RECOMMENDED_ACTIONS: 'Recommended Actions',
  USERS: 'Users',
}

export const INSIGHT_CRITICALITY_LEVEL = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  critical: 'Critical',
}
